import React, { useMemo } from 'react'
import { Button, Space } from 'antd'
import { isEmpty, isNil } from 'lodash'
import PropTypes from 'prop-types'

import { PermissionGuard } from '../routes'
import { StyledPageActions, StyledPageHeader } from '../styled'

const FormButtons = ({
  permissions,
  onReset,
  onSave,
  saveText,
  isDisabled,
}) => {
  const buttons = useMemo(
    () => (
      <StyledPageHeader>
        <StyledPageActions>
          <Space>
            <Button htmlType="button" ghost danger onClick={onReset}>
              Cancel
            </Button>

            <Button
              type="primary"
              onClick={onSave}
              htmlType={isNil(onSave) ? 'submit' : undefined}
            >
              {saveText}
            </Button>
          </Space>
        </StyledPageActions>
      </StyledPageHeader>
    ),
    [onReset, onSave, saveText],
  )

  if (isDisabled) {
    return null
  }

  return isEmpty(permissions) ? (
    buttons
  ) : (
    <PermissionGuard permissions={permissions}>{buttons}</PermissionGuard>
  )
}

FormButtons.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  onReset: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  onSave: PropTypes.func,
  saveText: PropTypes.string,
}

FormButtons.defaultProps = {
  permissions: [],
  isDisabled: false,
  onSave: undefined,
  saveText: 'Save',
}

export default FormButtons
